export default __webpack_public_path__ + "static/media/uploader-abbottNeo-4.9db3f715.png";